import React from "react";
import { Font, Page, Text, View, Document, Image } from "@react-pdf/renderer";

import RobotoMediumFont from "../../util/Fonts/Roboto-Medium.ttf";
import RobotoMediumItalic from "../../util/Fonts/Roboto-MediumItalic.ttf";
import RobotoRegular from "../../util/Fonts/Roboto-Regular.ttf";
import commonStyles from "../OnboardingForms/PDFStyles/common";
import styles from "./PdfStyles";
import { getDeclarationPlace } from "../../util/onBoardingDataFilters";
import { getFormattedDate, getImage } from "../../util/helpers";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: RobotoRegular
    },
    {
      src: RobotoMediumFont,
      fontWeight: "medium"
    },
    {
      src: RobotoMediumItalic,
      fontWeight: "medium",
      fontStyle: "italic"
    }
  ]
});

export const PDFTemplate = ({
  employeeDetails = {},
  pdfType = "Leave Encashment",
  showBoth = null
}) => {
  const isLeaveEnchashment = pdfType === "Leave Encashment";
  const pdf = isLeaveEnchashment => (
    <Page size="A4" style={styles.page}>
      <View>
        <Text style={{ ...styles.title, textAlign: "right" }}>
          Associate ID:
          <Text style={commonStyles.paddingLeft10}>
            {employeeDetails && employeeDetails.cdkEmployeeId}
          </Text>
        </Text>

        <Text
          style={{
            ...styles.title,
            ...commonStyles.textCenter,
            ...commonStyles.textUnderline,
            ...commonStyles.marginTop20
          }}
        >
          UNDERTAKING
        </Text>
        <Text style={commonStyles.marginTop10}>
          I,{" "}
          <Text
            style={{
              ...commonStyles.textUnderline,
              ...commonStyles.paddingLeft10
            }}
          >
            {employeeDetails && employeeDetails.cdkEmployeeName}
          </Text>
          {"  "}
          do hereby solemn affirm as under:-
        </Text>
        <Text
          style={{
            ...commonStyles.paddingLeft10,
            ...commonStyles.marginTop20
          }}
        >
          1. That I have not claimed any exemption against the payment of
          {isLeaveEnchashment ? " Leave Encashment" : " Gratuity"} prior to
          employment with CDK GLOBAL INDIA PVT LTD (the company), under the
          provisions of section 10(10) of the Income Tax Act, 1961.
        </Text>
        <Text
          style={{
            ...commonStyles.paddingLeft10,
            ...commonStyles.marginTop20
          }}
        >
          2. That I undertake to reimburse the company any tax, interest and
          penalty that arise to the company on account of
          {isLeaveEnchashment ? " Leave Encashment" : " Gratuity"} received from
          the Company assumed to be the
          {isLeaveEnchashment ? " Leave Encashment" : " Gratuity"} exceeding the
          maximum nontaxable limit for the purpose of deduction of tax at source
          by the Company.
        </Text>
        <View style={styles.signature}>
          <View
            style={{
              ...styles.employeeDateAndPlace,
              ...commonStyles.marginTop20
            }}
          >
            <View style={styles.flexDirectionRow}>
              <Text>Date:</Text>
              <Text style={commonStyles.paddingLeft10}>
                {getFormattedDate(employeeDetails.employeeDateOfLeaving)}
              </Text>
            </View>
            <View style={styles.flexDirectionRow}>
              <Text>Place:</Text>
              <Text style={commonStyles.paddingLeft10}>
                {getDeclarationPlace(
                  employeeDetails && employeeDetails.employeePlace
                )}
              </Text>
            </View>
          </View>
          <View
            style={{ ...styles.employeeSignature, ...commonStyles.marginTop20 }}
          >
            <View style={styles.flexDirectionRow}>
              <Text>Signature of the Employee:</Text>
              {
                <Image
                  style={styles.image}
                  src={
                    showBoth === false || showBoth === true
                      ? getImage(
                          employeeDetails.employeeSignature,
                          "images/CDKEmployee/Signature"
                        )
                      : URL.createObjectURL(employeeDetails.employeeSignature)
                  }
                />
              }
            </View>
            <View style={styles.flexDirectionRow}>
              <Text>Name of the Employee:</Text>
              <Text
                style={{
                  ...commonStyles.paddingLeft10,
                  ...commonStyles.paddingRight130
                }}
              >
                {employeeDetails && employeeDetails.cdkEmployeeName}
              </Text>
            </View>
          </View>
        </View>
      </View>
      <View style={styles.signatureLine} />
      <View style={commonStyles.marginTop10}>
        <Text
          style={{
            ...styles.title,
            ...commonStyles.textUnderline,
            ...commonStyles.marginTop20
          }}
        >
          VERIFICATION (Office use only)
        </Text>
        <Text style={commonStyles.marginTop10}>
          CDK hereby declares that what is stated above is true to the best of
          our knowledge and belief.
        </Text>
        <View style={styles.signature}>
          <View style={styles.employeeDateAndPlace}>
            <View style={styles.flexDirectionRow}>
              <Text>Verified Date:</Text>
              <Text></Text>
            </View>
            <View style={styles.flexDirectionRow}>
              <Text>Place:</Text>
              <Text></Text>
            </View>
          </View>
          <View style={styles.employeeSignature}>
            <View style={styles.flexDirectionRow}>
              <Text>Signature of the Employer:</Text>
              <Text></Text>
            </View>
            <View style={styles.flexDirectionRow}>
              <Text>Name of the Employer:</Text>
              <Text></Text>
            </View>
          </View>
        </View>
      </View>
    </Page>
  );

  return (
    <Document>
      {pdf(isLeaveEnchashment)}
      {showBoth && pdf(false)}
    </Document>
  );
};
